import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Line = styled.div`
  width: 100%;
  height: 1px;
  border: solid 1px ${ColorPalette.HEX.BrightGray};
`;

export const PreferencesContainer = styled.div``;

export const MenuItem = styled.div`
  position: relative;
  display: flex;
  margin: 0 16px;
  height: 81px;
  align-items: center;

  cursor: pointer;

  &:not(:first-child) {
    border-top: solid 1px ${ColorPalette.HEX.BrightGray};
  }
`;

export const ItemTitle = styled.div`
  margin-left: 10px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  color: ${ColorPalette.HEX.PineTree};
`;

export const Icon = styled.img`
  height: 100%;
`;

export const IconEdit = styled.img`
  cursor: pointer;
  right: 18px;
  position: absolute;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  div {
    width: 100%;
  }
`;

export const Container = styled.section`
  background-color: ${ColorPalette.HEX.Lotion};
  @media ${({ theme }) => theme.device.desktop} {
    background: none;
    max-width: 1300px;
  }
`;

export const HeaderTitle = styled.label`
  font-weight: 600;
  line-height: 80px;
  letter-spacing: -0.2px;
  text-align: center;
  padding: 0px;
  color: ${({ theme }) => theme.simpleHeader.titleColor};
`;

export const HeaderEdit = styled.button`
  font-weight: 600;
  text-align: right;
  color: ${ColorPalette.HEX.BrightOrange};
  font-size: 19px;
  cursor: pointer;
  background: ${ColorPalette.Transparent};

  @media ${({ theme }) => theme.device.mobile} {
    position: absolute;
    right: 24px;
    top: 28px;
    font-size: 14px;
  }
`;

export const PreferencesTitle = styled.h4`
  font-size: 24px;
  font-weight: 600;
  margin: 25px 0 32px 16px;
  line-height: 1.33;
  letter-spacing: -0.4px;
  color: ${ColorPalette.HEX.PineTree};
`;
